import { Attributes, LookupBase } from "@singularsystems/neo-core";
import Dividend from "../Dividend";
import DividendAccrualLookup from "./DividendAccrualLookup";

export default class DividendLookup extends LookupBase {

    constructor(accrual: DividendAccrualLookup) {
        super();

        this.accrual = accrual;
        this.dividend = accrual.dividend;

        this.makeObservable();
    }

    @Attributes.Raw()
    public accrual: DividendAccrualLookup;

    @Attributes.ChildObject(Dividend)
    public dividend: Dividend | null = null;

    @Attributes.Raw()
    public calculations: DividendAccrualLookup[] = [];

    @Attributes.Observable()
    public isExpanded = false;

    @Attributes.Date()
    public get cycleDate() {
        return this.dividend?.cycleDate ?? this.accrual.dividendCycleDate;
    }

    @Attributes.Date()
    public get calculationDate() {
        return this.accrual.startDate;
    }

    @Attributes.Date()
    public get paidDate() {
        return this.dividend?.payDate ?? null;
    }

    public get lastAccrual() {
        return this.calculations[this.calculations.length - 1];
    }

    @Attributes.Float()
    public get calculatedAmount() {
        return this.lastAccrual?.closingAccrued ?? 0;
    }

    @Attributes.Float()
    public get processedAmount() {
        return this.dividend?.dividendAmount;
    }

    @Attributes.Float()
    public get dividendTax() {
        return this.dividend ? -this.dividend.dividendTax : null;
    }

    @Attributes.Float()
    public get paidAmount() {
        return this.dividend?.paidAmount ?? null;
    }

    @Attributes.Float()
    public get reInvested() {
        return this.dividend?.reinvestAmount ?? null;
    }
}